import React, { useState, useEffect, useRef } from "react";
import {
    MessageCircle,
    X,
    Send,
    ChevronUp,
    ChevronDown,
    User,
    Paperclip,
    Smile,
    Check,
    CheckCheck,
    Image as ImageIcon,
    File,
    Mic,
    MoreVertical,
    Search,
    Users,
} from "lucide-react";
import { useDispatch, useSelector } from "react-redux";
import { getChatHistory, pushMessage, sendChatMessage } from "../../redux/reduxSlices/chatSlice";
import { connectChatSocket, disconnectChatSocket } from "../../utils/chatSocket";

const FloatingChatRoom = ({ user }) => {
    const dispatch = useDispatch()
    const [isOpen, setIsOpen] = useState(false);
    const [isMinimized, setIsMinimized] = useState(false);
    const [message, setMessage] = useState("");
    const [messages, setMessages] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [activeTab, setActiveTab] = useState("chat");
    const messagesEndRef = useRef(null);
    const { chatHistoryResponse } = useSelector((state) => state.chat)
    // console.log("uuuuuu", user)
    useEffect(() => {
        dispatch(getChatHistory())
    }, [])
    // console.log("chat ", chatHistoryResponse)

    // Toggle chat window
    const toggleChat = () => {
        setIsOpen(!isOpen);
        if (isOpen && isMinimized) {
            setIsMinimized(false);
        }
    };

    useEffect(() => {
        const token = localStorage.getItem("token");

        connectChatSocket(token, (raw) => {
            //  console.log("[WS INCOMING]", raw);
            let payload;
            try {
                const data = JSON.parse(raw);

                payload = {
                    ...data,
                    id: data.id ?? `ws-${Date.now()}`,
                    // ✅ Use sender info coming from server
                    username: data.username ?? data.user,
                    user_id: data.user_id,                 // <-- DO NOT override
                };
            } catch {
                payload = {
                    id: `ws-${Date.now()}`,
                    message: raw,
                    user_id: user.user_id,
                    username: `${user.first_name} ${user.last_name}`,
                };
            }


            dispatch(pushMessage(payload));
            setTimeout(() => {
                messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
            }, 100);
        });

        return () => disconnectChatSocket();
    }, [dispatch, user.user_id]);



    // Minimize/Maximize
    const toggleMinimize = () => {
        setIsMinimized(!isMinimized);
    };

    // Send message
    const sendMessage = async () => {
        if (!message.trim()) return;

        try {
            const response = await dispatch(sendChatMessage(message)).unwrap()
            // await dispatch(getChatHistory())
            setMessage("")
        } catch (error) {
            console.log("error", error)
        }
    };

    // Handle Enter key
    const handleKeyPress = (e) => {
        if (e.key === "Enter" && !e.shiftKey) {
            e.preventDefault();
            sendMessage();
        }
    };

    // Scroll to bottom
    useEffect(() => {
        if (isOpen && !isMinimized) {
            messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
        }
    }, [messages, isOpen, isMinimized]);

    // Auto update message status
    // useEffect(() => {
    //     const interval = setInterval(() => {
    //         setMessages(prev =>
    //             prev.map(msg =>
    //                 user.user_id==msg.user_id && msg.status === "sent"
    //                     ? { ...msg, status: "delivered" }
    //                     : msg
    //             )
    //         );
    //     }, 1000);

    //     return () => clearInterval(interval);
    // }, []);

    return (
        <>
            {/* Floating Chat Button */}
            <button
                onClick={toggleChat}
                className={`fixed bottom-6 right-6 z-50 flex items-center justify-center rounded-full shadow-lg transition-all duration-300 hover:shadow-xl ${isOpen
                    ? "bg-gradient-to-br from-orange-500 to-orange-600 text-white"
                    : "bg-white text-orange-600 border border-orange-200"
                    }`}
                style={{
                    width: isOpen ? "auto" : "56px",
                    height: "56px",
                    padding: isOpen ? "0 20px" : "0",
                }}
            >
                {isOpen ? (
                    <div className="flex items-center gap-2">
                        <X className="w-5 h-5" />
                        <span className="text-sm font-medium">Close Chat</span>
                    </div>
                ) : (
                    <div className="relative">
                        <MessageCircle className="w-6 h-6" />
                        {/* Online indicator */}
                        <div className="absolute -top-1 -right-1 w-3 h-3 bg-green-500 border-2 border-white rounded-full"></div>
                    </div>
                )}
            </button>

            {/* Chat Window */}
            {isOpen && (
                <div
                    className={`fixed right-6 z-40 bg-white rounded-lg border border-gray-200 shadow-2xl transition-all duration-300 ${isMinimized ? "bottom-20 w-80 h-16" : "bottom-24 w-[350px] h-[500px]"
                        }`}
                >
                    {/* Header */}
                    <div className="flex items-center justify-between p-4 border-b border-gray-200 bg-gradient-to-r from-orange-50 to-white">
                        <div className="flex items-center gap-3">
                            <div className="relative">
                                <div className="w-8 h-8 rounded-full bg-gradient-to-br from-orange-500 to-orange-600 flex items-center justify-center">
                                    <MessageCircle className="w-4 h-4 text-white" />
                                </div>
                                <div className="absolute -top-1 -right-1 w-3 h-3 bg-green-500 border-2 border-white rounded-full"></div>
                            </div>
                            <div>
                                <h3 className="font-bold text-gray-900">Team Chat Room</h3>
                                {/* <div className="flex items-center gap-1">
                                    <div className="w-2 h-2 bg-green-500 rounded-full"></div>
                                    <span className="text-xs text-green-600">
                                        {onlineUsers.filter(u => u.online).length} online
                                    </span>
                                </div> */}
                            </div>
                        </div>

                        <div className="flex items-center gap-2">
                            <button
                                onClick={toggleMinimize}
                                className="p-1 text-gray-400 hover:text-gray-600"
                            >
                                {isMinimized ? (
                                    <ChevronUp className="w-5 h-5" />
                                ) : (
                                    <ChevronDown className="w-5 h-5" />
                                )}
                            </button>
                            <button
                                onClick={toggleChat}
                                className="p-1 text-gray-400 hover:text-gray-600"
                            >
                                <X className="w-5 h-5" />
                            </button>
                        </div>
                    </div>

                    {!isMinimized && (
                        <>
                            {/* Content */}
                            <div className="flex-1 overflow-hidden">
                                <>
                                    {/* Messages Container */}
                                    <div className="h-80 overflow-y-auto p-4 bg-gradient-to-b from-white to-orange-50/20">
                                        {chatHistoryResponse.map((msg) => (
                                            <div
                                                key={msg.id}
                                                className={`mb-3 ${user.user_id == msg.user_id ? "text-right" : "text-left"}`}
                                            >
                                                <div className={`inline-block max-w-[85%] ${user.user_id == msg.user_id ? "ml-auto" : ""}`}>
                                                    {/* Sender Info (for others' messages) */}
                                                    {user.user_id != msg.user_id && (
                                                        <div className="flex items-center gap-2 mb-1">
                                                            <div className="w-6 h-6 rounded-full bg-gradient-to-br from-orange-100 to-orange-200 flex items-center justify-center text-xs font-medium text-orange-700">
                                                                {msg.username && msg.username.length > 0 ?
                                                                    msg.username.charAt(0).toUpperCase() :
                                                                    "U"}
                                                            </div>
                                                            <span className="text-xs font-medium text-gray-700">
                                                                {msg.username && msg.username.length > 0 ?
                                                                    msg.username.charAt(0).toUpperCase() + msg.username.slice(1).toLowerCase() :
                                                                    "User"}
                                                            </span>
                                                        </div>
                                                    )}
                                                    {/* Message Bubble */}
                                                    <div
                                                        className={`rounded-2xl px-4 py-2.5 ${user.user_id == msg.user_id
                                                            ? "bg-gradient-to-br from-orange-500 to-orange-600 text-white rounded-br-none"
                                                            : "bg-white border border-gray-200 text-gray-900 rounded-bl-none"
                                                            }`}
                                                    >
                                                        <div className="flex flex-wrap">
                                                            <p className="text-sm break-words whitespace-pre-wrap overflow-wrap-break-word min-w-0">
                                                                {msg.message}
                                                            </p>
                                                        </div>
                                                        <div className={`flex items-center gap-1 mt-1 ${user.user_id == msg.user_id ? "justify-end" : "justify-start"}`}>
                                                            {/* <span className={`text-xs ${user.user_id == msg.user_id ? "text-orange-200" : "text-gray-400"}`}>
                                                                {msg.time}
                                                            </span> */}
                                                            {user.user_id == msg.user_id && msg.status && (
                                                                <>
                                                                    {msg.status === "sent" && (
                                                                        <Check className="w-3 h-3 text-orange-200" />
                                                                    )}
                                                                    {msg.status === "delivered" && (
                                                                        <CheckCheck className="w-3 h-3 text-orange-200" />
                                                                    )}
                                                                    {msg.status === "read" && (
                                                                        <CheckCheck className="w-3 h-3 text-green-300" />
                                                                    )}
                                                                </>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}

                                        {isLoading && (
                                            <div className="text-left mb-3">
                                                <div className="flex items-center gap-2 mb-1">
                                                    <div className="w-6 h-6 rounded-full bg-gray-100 flex items-center justify-center">
                                                        <User className="w-3 h-3 text-gray-400" />
                                                    </div>
                                                    <span className="text-xs text-gray-500">Typing...</span>
                                                </div>
                                                <div className="w-24 bg-white border border-gray-200 rounded-2xl rounded-bl-none px-4 py-2.5">
                                                    <div className="flex gap-1">
                                                        <div className="w-2 h-2 bg-gray-300 rounded-full animate-bounce"></div>
                                                        <div className="w-2 h-2 bg-gray-300 rounded-full animate-bounce" style={{ animationDelay: "0.2s" }}></div>
                                                        <div className="w-2 h-2 bg-gray-300 rounded-full animate-bounce" style={{ animationDelay: "0.4s" }}></div>
                                                    </div>
                                                </div>
                                            </div>
                                        )}

                                        <div ref={messagesEndRef} />
                                    </div>

                                    {/* Message Input */}
                                    <div className="border-t border-gray-200 p-3">
                                        <div className="flex items-center justify-center gap-2">
                                            <div className="flex-1 relative">
                                                <textarea
                                                    value={message}
                                                    onChange={(e) => setMessage(e.target.value)}
                                                    onKeyPress={handleKeyPress}
                                                    placeholder="Type your message here..."
                                                    rows="1"
                                                    className="w-full px-3 py-2 pr-10 bg-gray-50 border border-gray-300 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-transparent resize-none max-h-24"
                                                />
                                            </div>
                                            <button
                                                onClick={sendMessage}
                                                disabled={!message.trim() || isLoading}
                                                className={`p-2.5 rounded-xl ${message.trim() && !isLoading
                                                    ? "bg-gradient-to-br from-orange-500 to-orange-600 hover:from-orange-600 hover:to-orange-700"
                                                    : "bg-gray-200"
                                                    } text-white transition-colors`}
                                            >
                                                <Send className="w-4 h-4" />
                                            </button>
                                        </div>
                                        <p className="text-xs text-gray-400 mt-2 text-center">
                                            Press Enter to send • Shift + Enter for new line
                                        </p>
                                    </div>
                                </>
                            </div>
                        </>
                    )}
                </div>
            )}
        </>
    );
};

export default FloatingChatRoom;